import React from 'react';
import { MessageBar, MessageBarType } from '@fluentui/react/lib/MessageBar';
import { BasePost, ChildPost, PrincipalId } from '../../../RootPost';

export interface HiddenTextInfoProps {
    post: BasePost;
    currentUserId: PrincipalId;
}

export default function HiddenTextInfo({ post, currentUserId }: HiddenTextInfoProps): JSX.Element {
    return (<>
        {!post.isClean && (post as ChildPost).reaction !== "reactYes" && post.author.id !== currentUserId && <MessageBar messageBarType={MessageBarType.info}>
            {/* {post.author.id === currentUserId && <span style={{ fontSize: "1.4rem" }}>This text is pending automated approval. It may take a few minutes until others can see it.</span>} */}
            {post.author.id !== currentUserId && <span style={{ fontSize: "1.4rem" }}>This post is pending automated or moderator approval.</span>}
        </MessageBar>}
        {post.isDeleted && <MessageBar messageBarType={MessageBarType.warning}>
            <span style={{ fontSize: "1.4rem" }}>This post is deleted. You can see it because you are a moderator or admin.</span>
        </MessageBar>}
    </>);
}
